// Filter predicate: which programmes show up in dropdowns/filters that group by cluster.
// Hides programmes that are linked to a cluster, except graduaten (those stay individually selectable).
// NOTE: the graduaat exception is intended for academic year 2025-2026 only. The plan
// is that from the next academic year onwards the graduaten programme
// manager will enter a single "IT graduaten" programme in SAT instead of 3 + the IT graduaten.
// If/when that happens, this exception can be removed.
export const isShownInOpleidingenFilter = p => !(p.clusterProgrammeId && p.programmeType !== 1);

// Sorts programmes:
// 1. Each cluster (alphabetical), immediately followed by its children (alphabetical)
// 2. Standalone programmes (alphabetical)
// The `programmes` argument is filtered first by `filterFn` (if provided), then sorted.
export function sortProgrammesLikeOpleidingenPage(programmes, filterFn = () => true) {
  const visible = programmes.filter(filterFn);
  const byName = (a, b) => a.name.localeCompare(b.name);

  const clusters = visible.filter(p => p.isCluster).sort(byName);
  const result = [];

  clusters.forEach(cluster => {
    result.push(cluster);
    visible
      .filter(p => !p.isCluster && p.clusterProgrammeId === cluster.ID)
      .sort(byName)
      .forEach(child => result.push(child));
  });

  visible
    .filter(p => !p.isCluster && !p.clusterProgrammeId)
    .sort(byName)
    .forEach(p => result.push(p));

  return result;
}
